import store from 'src/js/store';
import getDomainHosting from 'src/js/modules/config/selectors/domain-hosting';

const isCustomDomain = (vhost) => {
  const state = store.getState();
  const domainHosting = getDomainHosting(state);
  if (!domainHosting) return false;

  return !vhost.endsWith(`.${domainHosting}`);
};

export default isCustomDomain;
